import type { Mesh } from "eutopia.ts";
import {
  container,
  createLayer,
  createLayerType,
  object,
  positionTransition,
  quaternionTransition,
  yawPitchRollToQuat,
} from "eutopia.ts";
import { $, resolve, signal } from "signlets";

import type { State } from "../model";
import { scaleOpacity } from "./color";
import { loadObj } from "./obj";
import { stem } from "./stem";

export type VehicleProps = {
  state: State | undefined;
  onFollow: () => void;
};

export const vehicle = createLayerType<VehicleProps>(
  (context, { state, onFollow }) => {
    const [mesh, setMesh] = signal<Mesh>({ vertices: [], indices: [] });

    void loadObj(
      new URL("../world/silent-arrow.obj", import.meta.url).toString(),
    ).then(({ vertices, normals, indices }) =>
      setMesh({
        vertices: vertices.map((_, i) => ({
          position: vertices[i] ?? [0, 0, 0],
          normal: normals[i] ?? [0, 0, 0],
        })),
        indices,
      }),
    );

    const position = positionTransition(
      $(() => resolve(state)?.position ?? [0, 0, 0]),
    );

    const orientation = quaternionTransition(
      $(() => yawPitchRollToQuat(resolve(state)?.orientation ?? [0, 0, 0])),
    );

    const color = $(() =>
      scaleOpacity([0.5, 0.5, 0.5, 1], resolve(state) ? 1 : 0),
    );

    return createLayer(
      context,
      container({
        layers: [
          object({
            mesh,
            instances: [
              {
                position,
                orientation,
                scale: 1,
                minScalePixels: 5,
                color,
                diffuse: color,
                onClick: onFollow,
                outline: [0, 0, 0, 1],
              },
            ],
            polygonOffset: -1000,
          }),
          stem({
            stems: [{ position, color }],
          }),
        ],
      }),
    );
  },
);
